var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',[_c('lead-news-container',{attrs:{"news":_vm.news}}),_vm._v(" "),_c('artworks-section'),_vm._v(" "),_c('secondary-news-container',{attrs:{"news":_vm.newsSec}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8fe89c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/HomeContainer.vue
// module id = null
// module chunks = 